@if (!mobile) {
  <div class="container">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a
          class="link font-5 uppercase"
          routerLink="/"
          (click)="closeSubMenus()"
          >Home</a
        >
      </li>
      @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
        <li class="breadcrumb-item">
          <a
            [hidden]="i == breadcrumbs.length - 1"
            [routerLink]="[breadcrumb.url]"
            class="link font-5 uppercase"
          >
            <span
              [innerHTML]="breadcrumbName(breadcrumb.name) | safeContent"
            ></span>
          </a>
          <span
            [hidden]="i != breadcrumbs.length - 1"
            class="fw-bold font-5 uppercase color--primary-blue"
            [innerHTML]="breadcrumbName(breadcrumb.name) | safeContent"
          >
          </span>
        </li>
      }
    </ol>
  </div>
}
